import { ReadonlyURLSearchParams } from 'next/navigation';

export const createUrlWithParams = (
  pathname: string,
  searchParams: ReadonlyURLSearchParams,
  key: string,
  value: string,
): string => {
  const params = new URLSearchParams(searchParams.toString());
  params.set(key, value);

  if (key === 'path') {
    params.delete('file');
  }

  return `${pathname}?${params.toString()}`;
};
